var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isPendingUnfavorite ? _c('InlineSvg', _vm._g({
    class: _vm.$style.trash,
    attrs: {
      "width": _vm.heartDimensions.width,
      "height": _vm.heartDimensions.height,
      "src": _vm.trashIconPath
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleHeartClick.apply(null, arguments);
      }
    }
  }, _vm.$listeners)) : _c('InlineSvg', _vm._g({
    class: _vm.$style.heart,
    attrs: {
      "width": _vm.heartDimensions.width,
      "height": _vm.heartDimensions.height,
      "src": _vm.heartIconPath
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleHeartClick.apply(null, arguments);
      }
    }
  }, _vm.$listeners));
}
var staticRenderFns = []

export { render, staticRenderFns }